import type { MantineLoaderComponent } from "@mantine/core";
import { forwardRef } from "react";
import classes from "./Loading.module.css";

/**
 * O mesmo anel do `Loader` oval do Mantine (traço de 1/8 do tamanho, três
 * quartos coloridos, uma volta a cada 1,2 s), desenhado em SVG (SA-1474).
 *
 * O oval do Mantine é a borda de um `::after`, e borda não conta como
 * conteúdo para o navegador: com ele na tela, o primeiro quadro com conteúdo
 * (FCP) da entrada no app só vinha quando as respostas da API liberavam a
 * página, 1,5 a 2,5 s depois de o JS estar pronto no Lighthouse de Conversas
 * em staging. SVG conta, então o FCP passa a ser o próprio spinner.
 *
 * Recebe de `Loader` a classe e as variáveis `--loader-size` e
 * `--loader-color`, como os loaders nativos.
 */
export const SvgOvalLoader: MantineLoaderComponent = forwardRef(
  ({ className, ...others }, ref) => (
    <svg
      {...others}
      ref={ref}
      viewBox="0 0 8 8"
      aria-hidden="true"
      className={`${classes.svgOval} ${className ?? ""}`}>
      <circle
        className={classes.svgOvalArc}
        cx="4"
        cy="4"
        r="3.5"
      />
    </svg>
  )
);

SvgOvalLoader.displayName = "SvgOvalLoader";
